const jsonUtil = (function () {
  return {
    toQuery: function (json) {
      var str = ""
      var query = ""
      for (var key in json) {
        str += key + "=" + json[key] + "&"
      }

      query = str.substring(0, str.length - 1)
      return query
    },
  }
})()

export default jsonUtil
